module.exports = __webpack_public_path__ + "static/media/VestasSans-Medium.93b076ea.svg";